import { createStore, applyMiddleware, compose } from 'redux';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';
import createHistory from 'history/createHashHistory';
import rootReducer from './reducers';
import axios from 'axios';
import reduxAxiosMiddleware from 'redux-axios-middleware';
import i18n from 'i18n';

export const history = createHistory();

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  responseType: 'json',
  headers: { 'GIFT-SESSION':  localStorage.getItem("GIFT-SESSION") || '' },
  timeout: 30000
});

const initialState = {};
const enhancers = [];
const middleware = [
  thunk,
  reduxAxiosMiddleware(apiClient, {
    returnRejectedPromiseOnError: true,
    interceptors: {
      response: [
        {
          success: (argument, response) => {
            localStorage.setItem('GIFT-SESSION', response.headers['gift-session']);
            return response;
          },
          error: (argument, error) => {
            // Network Error
            if (!error.response) {
              error.response = {
                data: {
                  message: i18n.t('common:errors:networkError')
                }
              };
            }
            return Promise.reject(error);
          }
        }
      ]
    }
  }),
  routerMiddleware(history)
];

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
);

export default createStore(
  connectRouter(history)(rootReducer),
  initialState,
  composedEnhancers
);



// WEBPACK FOOTER //
// ./src/store.js